<section class="tab-community">
  @switch (state().kind) {
    @case ('loading') {
      <div class="tab-community__skeleton" role="status" aria-busy="true">
        <span class="tab-community__sr-only">{{ copy.skeletonLabel }}</span>
        <span class="tab-community__skeleton-line tab-community__skeleton-line--title" aria-hidden="true"></span>
        <span class="tab-community__skeleton-line" aria-hidden="true"></span>
        <span class="tab-community__skeleton-block" aria-hidden="true"></span>
        <span class="tab-community__skeleton-block" aria-hidden="true"></span>
      </div>
    }

    @case ('error') {
      <div class="tab-community__error" role="alert">
        <p class="tab-community__error-text">{{ copy.loadError }}</p>
        <button type="button" class="tab-community__secondary" (click)="retry()">{{ copy.retry }}</button>
      </div>
    }

    @default {
      <header class="tab-community__header">
        <h3 class="tab-community__title">{{ profile() ? copy.titleEdit : copy.titleNew }}</h3>
        @switch (visibility()) {
          @case ('visible') {
            <p class="tab-community__status tab-community__status--visible">{{ copy.statusVisible }}</p>
          }
          @case ('hidden') {
            <p class="tab-community__status">{{ hiddenText() }}</p>
          }
          @case ('suspended') {
            <p class="tab-community__status tab-community__status--suspended">
              {{ bannerCopy.suspendedBefore }}<a [routerLink]="contactPath">{{ bannerCopy.suspendedLink }}</a>{{ bannerCopy.suspendedAfter }}
            </p>
          }
          @default {
            <p class="tab-community__intro">{{ copy.intro }}</p>
          }
        }
      </header>

      @if (notice(); as n) {
        <p
          class="tab-community__notice"
          [class.tab-community__notice--error]="n.tone === 'error'"
          role="status"
        >
          {{ n.text }}
        </p>
      }

      <!-- Solo existe con el estado cargado: al cambiar de cuenta se destruye y su PUT en vuelo se cancela (H1). -->
      <app-player-profile-form
        [profile]="profile()"
        [locked]="formLocked()"
        (saved)="onSaved($event)"
        (busyChange)="onFormBusy($event)"
      />

      @if (profile()) {
        <div class="tab-community__danger">
          @if (confirmingDelete()) {
            <div class="tab-community__confirm" role="alertdialog" aria-labelledby="tab-community-confirm-text">
              <p class="tab-community__confirm-text" id="tab-community-confirm-text">{{ copy.deleteConfirm }}</p>
              <div class="tab-community__confirm-actions">
                <button type="button" class="tab-community__danger-button" [disabled]="deleting()" (click)="confirmDelete()">
                  {{ copy.deleteYes }}
                </button>
                <button #cancelDeleteButton type="button" class="tab-community__secondary" (click)="cancelDelete()">{{ copy.deleteNo }}</button>
              </div>
            </div>
          } @else {
            <button #deleteButton type="button" class="tab-community__secondary" [disabled]="formBusy()" (click)="askDelete()">{{ copy.delete }}</button>
          }
        </div>
      }
    }
  }

  <!-- J3 (D33-D34): bandejas, historial y contador. No dependen del perfil propio: el historial
       sobrevive a borrar el perfil (las solicitudes cuelgan de la cuenta, B6). -->
  <app-play-requests />
</section>
